// extracted by mini-css-extract-plugin
export var brand = "_3t-9";
export var compact = "_3t-6";
export var extraSmall = "_3t-7";
export var icon = "_3t-0";
export var large = "_3t-4";
export var light = "_3t-1";
export var medium = "_3t-5";
export var outline = "_3t-b";
export var primaryDark = "_3t-a";
export var primaryLight = "_3t-8";
export var primaryModern = "_3t-c";
export var success = "_3t-2";
export var successSolid = "_3t-3";